import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  Renderer2,
  ViewChild
} from '@angular/core';
import { orderBy } from 'lodash';
import { SyndicateRole, ROLES_PRIORITY } from '@ipreo/muni-shared';
import { amountFormat } from '../../../gameday.constants';
import { GameDayModel } from '../../../../models/gameday-model';

export interface AggregatedOrdersAmount {
  id: number;
  name: string;
  amount: number;
  type?: string;
  warehouseId?: number;
  priority?: GameDayModel.AccountPriority;
  role?: SyndicateRole;
}

export interface ViewAggregatedOrdersAmount {
  id: number;
  name: string;
  amountFormatted: string;
}

@Component({
  selector: 'muni-gameday-top-orders-table',
  templateUrl: './top-orders-table.template.html',
  styleUrls: ['./top-orders-table.styles.scss']
})
export class TopOrdersTableComponent {
  @Input()
  public emptyMessage: string;
  @Input()
  public set orderAmounts(orderAmounts: AggregatedOrdersAmount[]) {
    this.setOrdersAmount(orderAmounts);
  }

  @Output()
  public events = new EventEmitter<any>();

  //noinspection JSMismatchedCollectionQueryUpdate
  public amounts: ViewAggregatedOrdersAmount[];

  @ViewChild('scroll')
  private scroll: ElementRef;

  constructor(private renderer: Renderer2) {}

  public resetScroll(): void {
    this.renderer.setProperty(this.scroll.nativeElement, 'scrollTop', '0');
  }

  private setOrdersAmount(
    orderAmounts: AggregatedOrdersAmount[] | undefined | null
  ) {
    const iteratees: any[] = ['amount', 'name'];
    const ordering: Array<'desc' | 'asc'> = ['desc', 'asc'];

    if (!!orderAmounts && orderAmounts.every((amount) => amount.amount === 0)) {
      iteratees[0] = (amount) => ROLES_PRIORITY.indexOf(amount.role);
      ordering[0] = 'asc';
    }

    this.amounts = orderBy<AggregatedOrdersAmount>(
      orderAmounts,
      iteratees,
      ordering
    ).map((orderAmount: AggregatedOrdersAmount) => ({
      ...orderAmount,
      amountFormatted: amountFormat.format(orderAmount.amount / 1000)
    }));
  }
}
